import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Jugos y Licuados Funcionales',
  desc: 'Bebidas para acompañar viandas, conservación y combos para vender.'
}, {
  title: 'Recetas para Ocasiones',
  desc: 'Menús premium para celebraciones con empaque y precios orientativos.'
}, {
  title: '100 Viandas listas para vender',
  desc: 'Catálogo amplio con fichas operativas para cocinar y porcionar.'
}, {
  title: 'Postres Caseros para Vender',
  desc: 'Postres individuales, empaques y vida útil para upsell.'
}, {
  title: 'Recetas Sin Azúcar ni Sin Gluten',
  desc: 'Opciones aptas para dietas especiales y etiquetado.'
}, {
  title: 'Menú 2 Semanas Listo',
  desc: 'Plan completo con lista de compras, cronograma y fichas resumidas.'
}, {
  title: 'Viandas para Bebés y Niños',
  desc: 'Recetas por edad, texturas seguras y protocolos de etiquetado.'
}, {
  title: 'Viandas Fitness y Control de Macros',
  desc: 'Platos con cálculo de macros por porción y packs para clientes.'
}, {
  title: 'Menú Vegano & Vegetariano',
  desc: 'Recetas vegetales equilibradas y swaps proteicos.'
}, {
  title: 'Pack Desayunos Saludables',
  desc: 'Overnight, bowls y smoothies listos para delivery matutino.'
}, {
  title: 'Viandas Económicas y Rentables',
  desc: 'Platos optimizados para bajo costo y buen margen.'
}, {
  title: 'Recetas para Congelar y Revender',
  desc: 'Protocolos de enfriado, envasado y envío frío.'
}, {
  title: 'Kits DIY para Viandas',
  desc: 'Kits con ingredientes medidos, instructivo y formato de venta.'
}, {
  title: 'Salsas y Aderezos Caseros',
  desc: 'Salsas para upsell y venta retail con vida útil y etiquetado.'
}, {
  title: 'Menú Escolar Saludable',
  desc: 'Almuerzos y meriendas para colegios, con fichas y formularios.'
}];
export const BonusesSection: React.FC = () => {
  return <section className="py-24 px-4 md:px-8 bg-white" data-id="element-27">
      <div className="max-w-6xl mx-auto" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-29">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-primary mb-4" data-id="element-30">
            🎁 15 BONOS INCLUIDOS — ¡GRATIS!
          </h2>
          <p className="text-xl text-brand-cta font-bold" data-id="element-31">
            Valor total de los bonos: $133.500
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-32">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index % 4 * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-lg shadow-brand-primary/5 border-l-4 border-brand-soft flex flex-col h-full" data-id="element-33">
              <div className="flex items-center justify-between mb-3" data-id="element-34">
                <span className="text-sm font-bold text-brand-medium bg-brand-cream px-3 py-1 rounded-full" data-id="element-35">
                  Bono #{index + 1}
                </span>
                <span className="text-xs font-bold text-white bg-brand-soft px-2 py-1 rounded" data-id="element-36">
                  HOY GRATIS
                </span>
              </div>
              <h3 className="text-lg font-bold text-brand-text-dark mb-2" data-id="element-37">
                {bonus.title}
              </h3>
              <p className="text-brand-text-medium text-sm mb-4 flex-grow" data-id="element-38">
                {bonus.desc}
              </p>
              <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-39">
                <p className="text-sm text-gray-400 line-through" data-id="element-40">
                  ANTES $8.900
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};